import { SamplePack } from '@arpeggi/shared'
import { theme } from '@arpeggi/ui'
import { useColorThief } from './useColorThief'
import { CRITERIA_SP_ID } from './usePriceCard'

const ZOOM_REMIX_SP_ID = 20

const getUploadText = (sp: SamplePack) => {
  // we add this flag for specific copy for just the Reo Cragun Zoom Remix
  const isZoomRemixSamplePack = sp.id === ZOOM_REMIX_SP_ID

  let uploadText = `Upload your remix on ${sp.user.displayName}'s sample pack page`

  if (isZoomRemixSamplePack) {
    uploadText = `Upload your remix on ${sp.user.displayName}'s sample pack page by December 9th`
  }

  return uploadText
}

export const useSPCollectionTabContent = (sp: SamplePack) => {
  const { palette } = useColorThief(sp.coverImage.url)
  const color = palette ? palette[1] : theme.colors.blackA100.value
  const colorSecondary = palette ? palette[0] : theme.colors.blackA100.value

  const showCommercialLicenseCopy = sp.id === CRITERIA_SP_ID

  return {
    color,
    colorSecondary,
    showCommercialLicenseCopy
  }
}
